<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('chainInoutOrderManage.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="chainInoutOrderManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-select v-model="chainInoutOrderManageInfo.conditions.orderType" style="width:100%"
              :placeholder="$t('chainInoutOrderManage.selectOutType')">
              <el-option label="请选择出库类型" value=""></el-option>
              <el-option label="集采" value="1000"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="chainInoutOrderManageInfo.conditions.inOrderId"
              :placeholder="$t('chainInoutOrderManage.inputInOrderId')">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryChainInoutOrderMethod()">
              <i class="el-icon-search"></i>
              {{ $t('chainInoutOrderManage.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('chainInoutOrderManage.collectOrder') }}</div>
      </div>
      <div class="">
        <el-table :data="chainInoutOrderManageInfo.chainInoutOrders" border style="width: 100%">
          <el-table-column prop="orderId" :label="$t('chainInoutOrderManage.orderId')" align="center">
          </el-table-column>
          <el-table-column prop="inOrderId" :label="$t('chainInoutOrderManage.inOrderId')" align="center">
          </el-table-column>
          <el-table-column prop="personName" :label="$t('chainInoutOrderManage.applicant')" align="center">
          </el-table-column>
          <el-table-column prop="csId" :label="$t('chainInoutOrderManage.supplierId')" align="center">
          </el-table-column>
          <el-table-column prop="csName" :label="$t('chainInoutOrderManage.supplierName')" align="center">
          </el-table-column>
          <el-table-column prop="stateName" :label="$t('chainInoutOrderManage.orderStatus')" align="center">
          </el-table-column>
          <el-table-column :label="$t('chainInoutOrderManage.operation')" align="center">
            <template slot-scope="scope">
              <el-button-group v-if="scope.row.state == '1001'">
                <el-button size="mini" @click="_openEditChainInoutOrderModel(scope.row)">
                  {{ $t('chainInoutOrderManage.edit') }}
                </el-button>
                <el-button size="mini" @click="_openDeleteChainInoutOrderModel(scope.row)">
                  {{ $t('chainInoutOrderManage.delete') }}
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </el-card>

    <add-chain-inout-order ref="addChainInoutOrder"></add-chain-inout-order>
    <edit-chain-inout-order ref="editChainInoutOrder"></edit-chain-inout-order>
    <delete-chain-inout-order ref="deleteChainInoutOrder"></delete-chain-inout-order>
  </div>
</template>

<script>
import { listChainInoutOrder } from '@/api/goods/chainInoutOrderApi'
import AddChainInoutOrder from '@/components/goods/addChainInoutOrder'
import EditChainInoutOrder from '@/components/goods/editChainInoutOrder'
import DeleteChainInoutOrder from '@/components/goods/deleteChainInoutOrder'
import { getShopId } from '@/api/shop/shopApi'

export default {
  components: {
    AddChainInoutOrder,
    EditChainInoutOrder,
    DeleteChainInoutOrder
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      chainInoutOrderManageInfo: {
        chainInoutOrders: [],
        total: 0,
        records: 1,
        conditions: {
          orderType: '',
          inOrderId: '',
          page: 1,
          row: 10
        }
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    console.log(getShopId);
    this._listChainInoutOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    async _listChainInoutOrders(page, rows) {
      this.chainInoutOrderManageInfo.conditions.page = page
      this.chainInoutOrderManageInfo.conditions.row = rows

      try {
        const res = await listChainInoutOrder(this.chainInoutOrderManageInfo.conditions)
        this.chainInoutOrderManageInfo.total = res.total
        this.chainInoutOrderManageInfo.records = res.records
        this.chainInoutOrderManageInfo.chainInoutOrders = res.data
        this.total = res.records
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openAddChainInoutOrderModal() {
      this.$refs.addChainInoutOrder.open()
    },
    _openEditChainInoutOrderModel(row) {
      this.$refs.editChainInoutOrder.open(row)
    },
    _openDeleteChainInoutOrderModel(row) {
      this.$refs.deleteChainInoutOrder.open(row)
    },
    _queryChainInoutOrderMethod() {
      this._listChainInoutOrders(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handleCurrentChange(val) {
      this._listChainInoutOrders(val, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
}

.ibox-title {
  border-color: #edf1f2;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  clear: both;
  padding: 15px 20px 20px 20px;
}
</style>